/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from './actionTypes';
import { CALL_API } from '../middlewares/api'

export function loginGoogle(access_token, code) {
  return {
 		[CALL_API]: {
      endpoint: "loginGoogle",
      method:"POST",
      body:{access_token, code},
      types: [types.LOGIN_GOOGLE_REQUEST, types.LOGIN_GOOGLE_SUCCESS, types.LOGIN_GOOGLE_FAILURE]
    }
  }
}

export function logout() {
  return {
 		[CALL_API]: {
      endpoint: "logout",
      method:"POST",
      body:{},
      types: [types.LOGOUT_REQUEST, types.LOGOUT_SUCCESS, types.LOGOUT_FAILURE]
    }
  }
}

export function saveProfile(newProfile, partial) {
  // console.log('ACTION')
  return {[CALL_API]: {
              endpoint: 'profile',
              body: {...newProfile, partial:partial},
              types: [types.PROFILE_REQUEST, types.PROFILE_SUCCESS, types.PROFILE_FAILURE]
            }}

}

export function change(newProfile) {
  return {type:types.SET_PROFILE}    
}


export function setProfile(newProfile) {
  return {type:types.SET_PROFILE, body:newProfile}    
}
